import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { baseUrl } from "@src/app/routes";

const BreadCrumb: React.FC<IProps> = ({
  data,
}: IProps) => {
  return (
    <Container>
      <Row>
        <Col>
          <S.Ul>
            <S.Li className="breadcrumb-item">
              <Link to={baseUrl}>Home</Link>
            </S.Li>
            {data.map((item, i) => {
              return (
                <S.Li className="breadcrumb-item" key={i}>
                  {item.link ? 
                    <Link to={item.link}>{item.name}</Link>
                    :
                    <>{item.name}</>
                  }
                </S.Li>
              );
            })}
          </S.Ul>
        </Col>
      </Row>
    </Container>
  )
};

export { BreadCrumb }